AGADash.Grid = (function () {
    var detailHandlerOk = false;

    function setFormatClass(format, element) {
        if (format.DataType === "N")
            $(element).addClass("text-right");
        else if ((format.DataType === "D") || (format.Title === ""))
            $(element).addClass("text-center");
    }

    function getHeadElement(data, formats) {
        var thead = document.createElement("thead");
        var tr = document.createElement("tr");
        $(tr).appendTo(thead);

        for (var i = 0; i < data.Dimensions.length; i++) {
            var th = document.createElement("th");
            setFormatClass(formats[i], th);

            var text = ("FA" === data.Dimensions[i]) ? "" : formats[i].Title;
            $(th).text(text).appendTo(tr);
        }
        return thead;
    };

    function getRow(data, formats, index) {
        var tr = document.createElement("tr");
        $(tr).attr("detailkey", AGADash.Common.getDetailKey(data, index, data.Dimensions));

        var record = AGADash.Common.getRecord(data, index);
        for (var i = 0; i < data.Dimensions.length; i++) {
            var td = document.createElement("td");
            setFormatClass(formats[i], td);
            var value = record[data.Dimensions[i]];

            // Verifica se é um fa
            if ("FA" === data.Dimensions[i]) {
                var img = document.createElement("i");
                $(img).addClass("fa " + value).appendTo(td);
                $(td).appendTo(tr);
            }
            else
                $(td).text(AGADash.Common.Formatter.formatByInfo(formats[i], value)).appendTo(tr);
        }

        // Verifica se tem cor
        if (record["COLOR"])
            $(tr).css("background-color", record["COLOR"]);

        return tr;
    };

    function getBodyElement(data, formats) {
        var tbody = document.createElement("tbody");

        for (var index = 0; index < data.Values.length; index++) {
            var row = getRow(data, formats, index);
            tbody.appendChild(row);
        }

        return tbody;
    };

    function getFormats(data) {
        var formats = [];
        for (var i = 0; i < data.Dimensions.length; i++) {
            var fmt = AGADash.Common.getFormatInfo(data, data.Dimensions[i]);
            if (fmt.Title === "FA")
                fmt.Title = "";
            formats.push(fmt);
        }
        return formats;
    };

    var showDetails = function (e) {
        var tr = e.target;
        var key = $(tr).attr("detailKey");
        if (!key) {
            tr = $(tr).closest("tr");
            key = $(tr).attr("detailKey");
        }

        // Selecionar outro
        $(tr).parent().find("tr").removeClass("active");
        $(tr).addClass("active");

        // detalhes
        if (key) {
            AGADash.Panel.loadDetails(tr, key);
        }

    };

    var render = function (body, data) {

        $(body).addClass("dash-grid-placeholder");

        var formats = getFormats(data);

        var root = document.createElement("div");
        var table = document.createElement("table");
        $(table).attr({
            "class": "table table-hover",
            "cellspacing": "0",
            "border": "0",
            "style": "border-collapse:collapse;"
        }).appendTo(root);
        $(table).append(getHeadElement(data, formats));
        $(table).append(getBodyElement(data, formats));

        // Permitir exportação 
        if (AGATableExport)
            AGATableExport.createLink(table);

        // Paginar
        AGADash.Pagination.paginate(table, 10);

        $(root).hide().appendTo(body).slideDown(500);

        if (!detailHandlerOk) {
            $(document).on("click", "tr[detailkey]:not(.active)", showDetails);
            detailHandlerOk = true;
        }
    };

    return {
        render: render
    };
})();

AGADash.Repository.register(201, AGADash.Grid);

